module.exports = __webpack_public_path__ + "img/cloud-vmware-1.2a62de7.jpg";